function data(data, form) {
	let arr = []
	let formData = new FormData()
	data.forEach(inp => {
		if (inp.name && inp.value) arr.push(inp.getAttribute('name'))
	})
	for (let i = 0; i < arr.length; i++) {
		let key = arr[i]
		if (key === 'file') {
			Array.prototype.forEach.call(
				form.querySelector(`[name="${key}"]`).files,
				file => formData.append('file[]', file),
			)
		} else {
			formData.append(key, new FormData(form).get(arr[i]))
		}
	}

	return formData
}